import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import API from "../api/api";
import ProductCard from "../components/ProductCard";
import { useLanguage } from "../i18n/LanguageContext";

function Products({ onAddToOrder }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const [products, setProducts] = useState([]);
  const { t } = useLanguage();

  useEffect(() => {
    API.get("/api/products")
      .then((res) => setProducts(res.data))
      .catch((err) => console.error("Error loading products", err));
  }, []);

  return (
    <div className="product-list">
      <h2 className="section-title">{isAdmin ? t("products.adminTitle") : t("products.title")}</h2>
      {products.length === 0 ? (
        <p style={{ textAlign: "center" }}>{t("products.empty")}</p>
      ) : (
        <div className="product-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} onAddToOrder={onAddToOrder} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Products;
